import React from "react";
export default function WebFetchTool({ payload, result }) {
  return (
    <div className="tool-card-body">
      <div className="tool-section">
        <h5>URL</h5>
        <pre className="tool-pre">{payload?.input?.url || ""}</pre>
      </div>
      {result && (
        <div className="tool-section">
          <h5>Fetched</h5>
          <pre className="tool-pre">{result.content_preview || ""}</pre>
        </div>
      )}
    </div>
  );
}
WebFetchTool.summarize = (p) => p?.input?.url || "";
